<!-- Quality_SkeletonOverlay.vue: ag-grid loading overlay drawn as skeleton rows,
     one block per displayed column at that column's width, so it lines up with
     the real headers. Used as gridOptions.loadingOverlayComponent. -->
<template>
  <div class="w-full h-full self-start overflow-hidden bg-white">
    <div
      v-for="n in rowCount"
      :key="'row-skel-' + n"
      class="flex items-center border-b border-gray-100"
      :style="{ height: rowHeight + 'px' }"
    >
      <div
        v-for="(width, i) in widths"
        :key="'cell-skel-' + i"
        class="px-4 shrink-0"
        :style="{ width: width + 'px' }"
      >
        <div v-if="width <= 48" class="h-4 w-4 mx-auto bg-gray-200 rounded animate-pulse"></div>
        <template v-else>
          <div class="h-4 w-4/5 bg-gray-200 rounded animate-pulse"></div>
          <div class="h-3 w-1/2 bg-gray-100 rounded animate-pulse mt-2"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quality_SkeletonOverlay',
  props: {
    params: { type: Object, required: true },
  },
  computed: {
    widths() {
      return (this.params.api?.getAllDisplayedColumns?.() || []).map(c => c.getActualWidth());
    },
    rowHeight() {
      return this.params.api?.getGridOption?.('rowHeight') || 100;
    },
    rowCount() {
      return 8;
    },
  },
};
</script>
